import {
    addNewRowToTable,
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoSimpleInputOutlined, RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {ProductVariantService} from "../../serverService/productVariantService/ProductVariantService";
import {useDebounce} from "@uidotdev/usehooks";
import AddNewVariant from "./addNewVariant/AddNewVariant";

export default function ProductVariant({productId}) {

    const size = 20;
    let page = 0;

    const service = new ProductVariantService()

    const [totalItems, setTotalItems] = useState(0);
    const [productVariantsListData, setProductVariantsListData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    const [titleFilter, setTitleFilter] = useState("");
    const [slugFilter, setSlugFilter] = useState("");

    const _titleFilter = useDebounce(titleFilter, 500);
    const _slugFilter = useDebounce(slugFilter, 500);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProductVariantsLiatFromServer()
        }
    }, [_titleFilter, _slugFilter]);

    function productVariantTablePreparation(number, id, title, price, compareAtPrice, enabled, defaultType, createdBy, createdAt
    ) {
        return {
            number,
            id,
            title,
            price: convertCurrencyFormatPositiveNegative(price),
            compareAtPrice: convertCurrencyFormatPositiveNegative(compareAtPrice),
            enabled: <RaikoCustomSimpleActiveDeActiveChip state={enabled} activeStateTitle={"فعال"}
                                                          deActiveStateTitle={"غیر فعال"}/>,
            defaultType: <RaikoCustomSimpleActiveDeActiveChip state={defaultType} activeStateTitle={"فعال"}
                                                              deActiveStateTitle={"غیر فعال"}/>,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
        }
    }

    function getProductVariantsLiatFromServer() {
        setTableLoading(true)
        service.getProductVariantList(productId, page, size, _titleFilter, _slugFilter)
            .then(response => {
                setTotalItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setProductVariantsListData([])
                response.data.map((item, index) => {
                    setProductVariantsListData(prevState => [
                        ...prevState,
                        productVariantTablePreparation(
                            (page * size) + index + 1,
                            item.id,
                            item.title,
                            item.price,
                            item.compareAtPrice,
                            item.enabled,
                            item.default,
                            item.createdBy,
                            item.createdAt,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePage(newPage) {
        page = newPage;
        getProductVariantsLiatFromServer()
    }

    const navigate = useNavigate()

    function showProductVariantDetails(variantId) {
        let _title = ""
        productVariantsListData.map((item) => {
            if (item.id === variantId)
                _title = item.title
        })
        navigate(RouteHelper.ProductVariantDetails.globalUrl.replace(":id", variantId),
            {state: {title: _title}, replace: false}
        )

    }

    function handleAddNewVariantToTable(item) {
        const _items = addNewRowToTable(
            productVariantTablePreparation(
                1,
                item.id,
                item.title,
                item.price,
                item.compareAtPrice,
                item.enabled,
                item.default,
                item.createdBy,
                item.createdAt,
            ),
            productVariantsListData
        );
        setProductVariantsListData(_items)
    }

    const [variantDialogState, setVariantDialogState] = useState(false)

    function handleCloseVariantDialog() {
        setVariantDialogState(false)
    }

    function handleOpenDialog() {
        setVariantDialogState(true)
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseVariantDialog}
                open={variantDialogState}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewVariant
                    handleCloseVariantDialog={handleCloseVariantDialog}
                    handleAddNewVariant={handleAddNewVariantToTable}
                    productId={productId}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"انواع محصول"}
                        amount={totalItems}
                        hasCreateNewItem
                        handleCreateNewItem={handleOpenDialog}
                    />
                    <RaikoTableSearchContainer
                        value={titleFilter}
                        setValue={setTitleFilter}
                        labelText={"عنوان"}
                        hasFilter
                    >
                        <RaikoSimpleInputOutlined
                            labelText={"slug"}
                            value={slugFilter}
                            setValue={setSlugFilter}
                        />
                    </RaikoTableSearchContainer>
                    <RaikoCustomTable
                        header={productVariantTableHeader}
                        data={productVariantsListData}
                        rowClicked={showProductVariantDetails}
                        pageCount={pageCount}
                        handlePaginationChange={handleChangePage}
                        isLoading={tableLoading}
                    />
                </RaikoGridOneColumn>

            </RaikoBaseCardContainer>
        </>
    )
}
const productVariantTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "price",
        label: "قیمت"
    },
    {
        id: "compareAtPrice",
        label: "قیمت قبل"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
    {
        id: "defaultType",
        label: "پیش فرض"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]